import { isNotUndefined } from 'infrastructure/functions';

import {
  additionalFollowUpText,
  compareToLastReview,
  croOrDncText,
  reviewedReadings,
  needEscalateText,
  uniqueDaysText,
  waitingDeviceReplacement,
} from '../helpers';

import type { TMaGlucoseYellowDataOptional } from '../../types';

export const glucose = (data: TMaGlucoseYellowDataOptional) => {
  let text = '';

  if (isNotUndefined(data.glucoseDeviceFunctioningProperly)) {
    text += `Patient glucometer ${
      data.glucoseDeviceFunctioningProperly ? 'is' : 'is not'
    } functioning properly. `;
  }
  if (data.glucoseDeviceFunctioningProperlyComment?.trim()) {
    text += `${data.glucoseDeviceFunctioningProperlyComment}. `;
  }

  const waitingDeviceReplacementText = waitingDeviceReplacement(
    data.waitingDeviceReplacement,
    data.waitingForDeviceReplacementList,
  );
  if (waitingDeviceReplacementText.trim())
    text += `\n${waitingDeviceReplacementText}`;
  if (data.waitingForDeviceReplacementComment?.trim()) {
    if (data.waitingDeviceReplacement === undefined) text += '\n';
    text += `${data.waitingForDeviceReplacementComment}. `;
  }

  const maReviewedReadingsText = reviewedReadings({
    template: 'MA',
    type: 'glucometer',
    atRiskNumber: data.atRiskNumber,
    thresholds: [
      {
        name: 'blood glucose',
        lowValue: data.lowestGlucose,
        highValue: data.highestGlucose,
      },
    ],
  });
  if (maReviewedReadingsText.trim()) text += `\n${maReviewedReadingsText}`;

  let trend = '';
  if (data.typeofTrend === 'high') {
    trend = 'High';
  }
  if (data.typeofTrend === 'low') {
    trend = 'Low';
  }
  if (data.typeofTrend === 'both') {
    trend = 'Both';
  }
  if (data.typeofTrend === 'other' && data.otherTypeofTrend?.trim()) {
    trend = data.otherTypeofTrend.trim();
  }
  if (trend) {
    text += '\n';
    text += `${trend} trends noted for patient’s blood glucose readings. `;
  }

  const comparedToLastReviewText = compareToLastReview(
    data.comparedToLastReview,
    data.comparedToLastReviewTrend,
  );
  if (comparedToLastReviewText.trim()) text += `\n${comparedToLastReviewText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysText(data.uniqueDays);
  }

  if (isNotUndefined(data.reviewClinicalDocumentation)) {
    text += '\n';
    text += `Patient ${
      data.reviewClinicalDocumentation ? 'reported' : 'did not report'
    } lifestyle factors that may be impacting at-risk values. `;
  }
  if (data.reviewClinicalDocumentationComment?.trim()) {
    if (data.reviewClinicalDocumentation === undefined) text += '\n';
    text += `${data.reviewClinicalDocumentationComment}. `;
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
